export const inverseMap = {
    primary: 'onPrimary',
    secondary: 'onSecondary',
    tertiary: 'onTertiary',
    surface: 'onSurface',
    error: 'onError',
    warning: 'onWarning',
    success: 'onSuccess',
    info: 'onInfo',

    onPrimary: 'primary',
    onSecondary: 'secondary',
    onTertiary: 'tertiary',
    onSurface: 'surface',
    onError: 'error',
    onWarning: 'warning',
    onSuccess: 'success',
    onInfo: 'info',

    primaryContainer: 'onPrimaryContainer',
    secondaryContainer: 'onSecondaryContainer',
    tertiaryContainer: 'onTertiaryContainer',
    surfaceContainer: 'onSurface',
    errorContainer: 'onErrorContainer',
    warningContainer: 'onWarningContainer',
    successContainer: 'onSuccessContainer',
    infoContainer: 'onInfoContainer',

    onPrimaryContainer: 'primaryContainer',
    onSecondaryContainer: 'secondaryContainer',
    onTertiaryContainer: 'tertiaryContainer',
    // onSurfaceContainer: 'surfaceContainer',
    onErrorContainer: 'errorContainer',
    onWarningContainer: 'warningContainer',
    onSuccessContainer: 'successContainer',
    onInfoContainer: 'infoContainer',
};

export const colorVariants = [
    'primary',
    'secondary',
    'tertiary',
    'surface',
    'error',
    'warning',
    'success',
    'info',
];
